import { useApi } from '@omnipresentgroup/api';
import type { BulkCompensationRequest } from '@omnipresentgroup/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useBulkCompensationMutation = ({
  onSuccess,
}: Omit<UseMutationOptions<unknown, unknown, unknown>, 'mutationFn'>) => {
  const { POST } = useApi();

  return useMutation({
    mutationFn: ({ companyId, type, url }: BulkCompensationRequest) => {
      return POST({
        path: `${API_BASE}/${API_PATH}/compensation/bulk`,
        body: {
          companyId,
          type,
          url,
        },
      });
    },
    onSuccess,
  });
};
